import { html, ViewTemplate, repeat, ref, when } from '@microsoft/fast-element';
import { MARKET_DEPTH_COLUMNS } from './column-config';
import type { MarketDepthGrid } from './market-depth-grid';

export const MarketDepthGridTemplate: ViewTemplate<MarketDepthGrid> = html`
  <div class="market-depth-component">
    <zero-grid-pro
      class="grid-styles"
      only-template-col-defs
      rowSelection="single"
      ${ref('marketDepthGrid')}
      @onGridReady="${(x) => x.onGridReady()}"
    >
      ${repeat(
        (x) => MARKET_DEPTH_COLUMNS(x),
        html`
          <grid-pro-column :definition="${(x) => x}"></grid-pro-column>
        `,
      )}
    </zero-grid-pro>

    ${when(
      (x) => x.showNoCriteriaSelectedOverlay,
      html<MarketDepthGrid>`
        <div class="no-criteria-wrapper">
          <h3 class="header">No Criteria Selected</h3>
          <p class="description">Please ensure required filters have been applied</p>
        </div>
      `,
    )}
  </div>
`;
